export default {
  usersList: [],
  manageUser: null,
  userSessionsList: [],
  userLoginsList: [],
  userEmailLogsList: [],
  userLearningPathList: [],
  userCanceledList: [],
  userProgramsList: []
}
